import { FC, createContext, useState } from 'react'
import { fabric } from 'fabric'
import PixelManipulationEditorEventManager from '../PixelManipulationEditorEventManager'

export interface IPixelManipulationEditorContext {
  canvas: fabric.Canvas | null
  setCanvas: (canvas: fabric.Canvas) => void
  activeObject: fabric.Object | null
  setActiveObject: (object: fabric.Object | null) => void
  editor: PixelManipulationEditorEventManager | null
  setEditor: (handlers: PixelManipulationEditorEventManager) => void
  zoomRatio: number
  setZoomRatio: (value: number) => void
}

export const PixelManipulationEditorContext = createContext<IPixelManipulationEditorContext>({
  canvas: null,
  setCanvas: () => {},
  activeObject: null,
  setActiveObject: () => {},
  editor: null,
  setEditor: () => {},
  zoomRatio: 1,
  setZoomRatio: () => {}
})

export const PixelManipulationEditorProvider: FC = ({ children }) => {
  const [canvas, setCanvas] = useState<fabric.Canvas | null>(null)
  const [activeObject, setActiveObject] = useState<fabric.Object | null>(null)
  const [editor, setEditor] = useState<PixelManipulationEditorEventManager | null>(null)
  const [zoomRatio, setZoomRatio] = useState(1)

  const context = {
    canvas,
    setCanvas,
    activeObject,
    setActiveObject,
    editor,
    setEditor,
    zoomRatio,
    setZoomRatio
  }

  return <PixelManipulationEditorContext.Provider value={context}>{children}</PixelManipulationEditorContext.Provider>
}
